import React, {useEffect, useReducer, useState} from 'react';
import PropTypes from 'prop-types';
import {IconButton, Popover, Typography} from "@material-ui/core";
import {set, insert, del} from 'object-path-immutable'
import ListHoc from "../../../../../HocHelpers/ListHoc";
import Errors from "./Errors";
import {
    checkForRequiredFields,
    defaultShadow,
    getOperands,
    isCustomShadowBox,
    setFilterColumns,
    setFilterValues
} from "./lib";
import PopoverActions from "./PopoverActions";
import JsonScreenHoc from "../../../../../HocHelpers/JsonScreenHoc";
import findByString from "../../../../../Utils/Form/FormDynamic/Utils/getValueByString";
import request from "../../../../../Services/API/Requests";
import {SelectionCriteriaContext} from "./SelectionCriteriaContext";
import {useSelector} from "react-redux";
import SelectionCriteriaDev from "../SelectionCriteriaDev/SelectionCriteriaDev";
import {getParamsFromString} from "../../../Utils";
import {Close} from "@material-ui/icons";
import Divider from "@material-ui/core/Divider";

const initialState = {
    operands: [],
    filterFields: [],
    currentFilterFront: [
        {
            field: {value: '', label: ''},
            operand: {value: '', label: ''},
            value: ''
        }
    ],
    currentFilter: [
        {field: '', operand: '', value: ''}
    ],
    initFilter: [{field: '', operand: '', value: ''}],
    initFilterFront: [{
        field: {value: '', label: ''},
        operand: {value: '', label: ''},
        value: ''
    }],
    errors: false,
    onLoadValue: false
};
export const ACTIONS = {
    INIT_DATA: 'init-data',
    UPDATE_DATA: 'update-data',
    UPDATE_CURRENT_FILTER: 'update-current-filter',
    SET_ERRORS: 'set-errors',
    SET_ON_LOAD_VALUE: 'set-on-load-value',
    RESTORE_TO_INIT: 'restore-to-init',
    UPDATE_INIT_DATA: 'update-init-data',
    INSERT_ONE_ROW: 'insert-one-row',
    SET_VALUE: 'set-value',
};

function init() {
    return initialState;
}

function reducer(state, {type, payload}) {
    switch (type) {
        case ACTIONS.INIT_DATA:
            return {
                ...state,
                filterFields: payload.filterFields,
                currentFilter: payload.currentFilter ? payload.currentFilter : state.currentFilter,
                currentFilterFront: payload.currentFilterFront ? payload.currentFilterFront : state.currentFilterFront,
                initFilter: payload.currentFilter ? payload.currentFilter : state.currentFilter,
                initFilterFront: payload.currentFilterFront ? payload.currentFilterFront : state.currentFilterFront,
                operands: payload.operands
            };
        case ACTIONS.UPDATE_DATA:
            return {
                ...state,
                currentFilter: payload.currentFilter,
                currentFilterFront: payload.currentFilterFront
            };
        case ACTIONS.UPDATE_CURRENT_FILTER:
            return {
                ...state,
                currentFilter: payload.currentFilter,
                currentFilterFront: payload.currentFilterFront
            };
        case ACTIONS.SET_ERRORS:
            return {
                ...state,
                errors: payload.errors
            };
        case ACTIONS.SET_ON_LOAD_VALUE:
            return {
                ...state,
                currentFilter: payload.currentFilter,
                currentFilterFront: payload.currentFilterFront,
                onLoadValue: true
            };
        case ACTIONS.RESTORE_TO_INIT:
            return {
                ...state,
                currentFilter: state.initFilter,
                currentFilterFront: state.initFilterFront
            };
        case ACTIONS.UPDATE_INIT_DATA:
            return {
                ...state,
                initFilter: payload.currentFilter,
                initFilterFront: payload.currentFilterFront
            }
        case ACTIONS.INSERT_ONE_ROW: {
            const emptyFilter = {field: "", operand: "", value: ''};
            const emptyFilterFront = {field: {label: "", value: ""}, operand: {label: "", value: ""}, value: ''};
            let newCurrentFilter = insert(state.currentFilter, '', emptyFilter, state.currentFilter.length);
            let newCurrentFilterFront = insert(state.currentFilterFront, '', emptyFilterFront, state.currentFilterFront.length);
            return {
                ...state,
                currentFilter: newCurrentFilter,
                currentFilterFront: newCurrentFilterFront
            }
        }
        case ACTIONS.SET_VALUE: {
            const {currentFilter, currentFilterFront} = state;
            const {path, value} = payload;
            const newCurrentFilter = set(currentFilter, path, value);
            const newCurrentFilterFront = set(currentFilterFront, path, value);
            return {
                ...state,
                currentFilter: newCurrentFilter,
                newCurrentFilterFront: newCurrentFilterFront
            }
        }

        default:
            return state;
    }
}

const SelectionCriteria = (props) => {
    const {
        onClose, anchorEl, isPopover, setFilterLength,
        columns, filterFields, advancedFilter, persistentFilter,
        listName, applyAdvancedFilter, history, listStyles, screenName,
        component: {properties = {}, styles: sourceStyles, events}, asComponent, globalValues, setValue, disabled,
        withoutGroups, doActions
    } = props;
    const listId = properties.listId ? getParamsFromString(properties.listId, globalValues, screenName) : "";
    const styles = sourceStyles ? sourceStyles[0] : {};
    const [state, dispatch] = useReducer(reducer, initialState, init);
    const isCustomBoxShadow = isCustomShadowBox(listStyles);
    const {userLanguage} = useSelector(state => state.app);
    const [actions, setActions] = useState(null)

    useEffect(() => {
        async function initData() {
            const operands = await getOperands();
            const filterColumns = await setFilterColumns(operands, filterFields, columns, userLanguage, properties.allColumns, persistentFilter);
            const {
                currentFilter,
                currentFilterFront
            } = await setFilterValues(advancedFilter, filterColumns, operands, setFilterLength);

            dispatch({
                type: ACTIONS.INIT_DATA,
                payload: {
                    filterFields: filterColumns,
                    currentFilter,
                    currentFilterFront,
                    operands
                }
            })
        }

        //do not init when component used from renderComponents
        if (Boolean(anchorEl) && !asComponent) {
            initData()
        }

    }, [userLanguage, JSON.stringify(advancedFilter), Boolean(anchorEl), JSON.stringify(persistentFilter)]);
    useEffect(() => {
        async function updateData() {
            const {filterFields, operands} = state;
            const {
                currentFilter,
                currentFilterFront
            } = await setFilterValues(advancedFilter, filterFields, operands, setFilterLength);
            dispatch({
                type: ACTIONS.UPDATE_DATA,
                payload: {
                    currentFilterFront,
                    currentFilter
                }
            });
            setFilterLength(advancedFilter.length)
        }

        !asComponent && updateData();
    }, [JSON.stringify(advancedFilter)]);


    // "as component type" side effects
    useEffect(() => {
        async function initData() {
            try {
                let operands = await getOperands();
                const listSchema = await request({
                    url: "list/read",
                    data: {id: listId}
                });

                const filterColumns = await setFilterColumns(operands, listSchema.filterFields, listSchema.columns, userLanguage, properties.allColumns);


                const {
                    currentFilter,
                    currentFilterFront
                } = await setFilterValues(advancedFilter, filterColumns, operands, setFilterLength, properties.defaultValueType);
                dispatch({
                    type: ACTIONS.INIT_DATA,
                    payload: {
                        filterFields: filterColumns,
                        currentFilter,
                        currentFilterFront,
                        operands
                    }
                });

                if (events && events[0].event === 'onApply') {
                    setActions(events[0].actions)
                }

            } catch (e) {
                console.log(e)
            }
        }

        asComponent && !disabled && initData();
    }, [JSON.stringify(properties), listId]);


    useEffect(() => {
        const currentValue = findByString(globalValues.param[screenName], properties.path);

        //do not insert initial value when local state equals with external
        if (JSON.stringify(currentValue) === JSON.stringify(state.currentFilter)) return;

        if (currentValue && !disabled) {
            async function initValue() {
                try {
                    const listSchema = await request({
                        url: "list/read",
                        data: {id: listId}
                    });
                    const operands = await getOperands();
                    const filterColumns = await setFilterColumns(operands, listSchema.filterFields, listSchema.columns, userLanguage, properties.allColumns);
                    const {
                        currentFilter,
                        currentFilterFront
                    } = await setFilterValues(currentValue, filterColumns, operands, setFilterLength);
                    dispatch({
                        type: ACTIONS.SET_ON_LOAD_VALUE,
                        payload: {
                            currentFilter: currentFilter,
                            currentFilterFront: currentFilterFront,
                            onLoadValue: true
                        }
                    });
                } catch (e) {
                    console.log('init selection criteria as component error', e)
                }
            }

            asComponent && !state.onLoadValue && initValue()
        }
    }, [findByString(globalValues.param[screenName], properties.path), listId]);

    useEffect(() => {
        if (asComponent && properties.path) {
            setValue(state.currentFilter, properties.path)
        }
    }, [properties.path, asComponent, JSON.stringify(state.currentFilter)]);

    //field handlers
    const onChangeField = (event, newValue, index) => {
        const {currentFilter, currentFilterFront} = state;
        const operandField = document.getElementById(`${listName}_${index}_operandField`);
        const operandLength = newValue?.operands?.length;
        let newCurrentFilter = set(currentFilter, `${index}.field`, newValue ? newValue.value : "");

        let newCurrentFilterFront = set(currentFilterFront, `${index}.field`, newValue ? newValue : {
            value: "",
            label: ""
        });

        //if only one operand defined for column, default it (field will be disabled by own condition)
        if (operandLength === 1) {
            let defaultedOperand = newValue.operands[0];
            newCurrentFilterFront = set(newCurrentFilterFront, `${index}.operand`, defaultedOperand)
            newCurrentFilter = set(newCurrentFilter, `${index}.operand`, defaultedOperand.value)
        }
        dispatch({
            type: ACTIONS.UPDATE_CURRENT_FILTER,
            payload: {
                currentFilterFront: newCurrentFilterFront,
                currentFilter: newCurrentFilter
            }
        });

       // operandField && operandField.focus();
    };
    const onChangeOperand = (event, newValue, index) => {
        const {currentFilter, currentFilterFront} = state;
        const filterValueField = document.getElementById(`${listName}_${index}_filterValueField`);
        const currentOperand = findByString(currentFilter, `${index}.operand.value`) //currentFilter[index].operand.value;

        let newCurrentFilter = set(currentFilter, `${index}.operand`, newValue ? newValue.value : "");
        let newCurrentFilterFront = set(currentFilterFront, `${index}.operand`, newValue ? newValue : {
            value: "",
            label: ""
        });

        //clear old value if operand was changed to range
        if (currentOperand === 'range' || currentOperand === '!range') {
            newCurrentFilter = set(newCurrentFilter, `${index}.value`, '')
        }

        dispatch({
            type: ACTIONS.UPDATE_CURRENT_FILTER,
            payload: {
                currentFilterFront: newCurrentFilterFront,
                currentFilter: newCurrentFilter
            }
        });

        filterValueField && filterValueField.focus()
    };
    const onChangeFilterValue = (event, index) => {
        const {currentFilter, currentFilterFront} = state;
        let newCurrentFilter = set(currentFilter, `${index}.value`, event.target.value);
        let newCurrentFilterFront = set(currentFilterFront, `${index}.value`, event.target.value);

        dispatch({
            type: ACTIONS.UPDATE_CURRENT_FILTER,
            payload: {
                currentFilterFront: newCurrentFilterFront,
                currentFilter: newCurrentFilter
            }
        });
    };
    const onChangeFilterValueExternal = (value, path) => {

        if (!path) return


        dispatch({
            type: ACTIONS.SET_VALUE,
            payload: {path, value}
        });


    };
    const onChangeFilterValueRange = (event, index) => {
        const {currentFilter, currentFilterFront} = state;
        let newCurrentFilter = set(currentFilter, `${index}.${event.target.name}`, event.target.value);
        let newCurrentFilterFront = set(currentFilterFront, `${index}.${event.target.name}`, event.target.value);

        dispatch({
            type: ACTIONS.UPDATE_CURRENT_FILTER,
            payload: {
                currentFilterFront: newCurrentFilterFront,
                currentFilter: newCurrentFilter
            }
        });
    };

    const onCreateFilter = (event, index, f) => {
        const {currentFilter} = state;
        if (index + 1 >= currentFilter.length) {
            event.preventDefault();
            setFilterLength(1);
            dispatch({
                type: ACTIONS.INSERT_ONE_ROW,
            });
            f && f()
        }

    };
    const onDeleteFilter = (index) => {
        const {currentFilter, currentFilterFront} = state;

        const emptyFilter = [{field: '', operand: '', value: ''}];
        const emptyFilterFront = [{field: {label: "", value: ""}, operand: {label: "", value: ""}, value: ''}];
        let newCurrentFilter = index < 1 ? emptyFilter : del(currentFilter, index);
        let newCurrentFilterFront = index < 1 ? emptyFilterFront : del(currentFilterFront, index);

        dispatch({
            type: ACTIONS.UPDATE_CURRENT_FILTER, payload: {
                currentFilterFront: newCurrentFilterFront,
                currentFilter: newCurrentFilter
            }
        });
        index < 1 && setFilterLength(0);
    };
    const onDeleteAllFilters = () => {
        const emptyFilter = [{field: '', operand: '', value: ''}];
        const emptyFilterFront = [{field: {label: "", value: ""}, operand: {label: "", value: ""}, value: ''}];
        setFilterLength(0);
        dispatch({
            type: ACTIONS.UPDATE_CURRENT_FILTER,
            payload: {currentFilterFront: emptyFilterFront, currentFilter: emptyFilter}
        });
    };

    const onChangeType = (type, index) => {
        const {currentFilter, currentFilterFront} = state;
        let newCurrentFilter = set(currentFilter, `${index}.type`, type);
        let newCurrentFilterFront = set(currentFilterFront, `${index}.type`, type);
        dispatch({
            type: ACTIONS.UPDATE_CURRENT_FILTER,
            payload: {
                currentFilterFront: newCurrentFilterFront,
                currentFilter: newCurrentFilter
            }
        });

    }

    const apply = (event) => {
        event.preventDefault();
        const {currentFilter, currentFilterFront} = state;
        const lastFilter = currentFilter[currentFilter.length - 1];
        const errors = checkForRequiredFields(currentFilter, filterFields || state.filterFields);

        if (errors) {
            dispatch({type: ACTIONS.SET_ERRORS, payload: {errors}});
            return;
        }

        //clear errors
        if (!errors) {
            dispatch({type: ACTIONS.SET_ERRORS, payload: {errors: false}});
        }

        if (asComponent && !errors) {
            actions && doActions(actions, {doc: currentFilter});
            return
        }

        if (currentFilter.length <= 1 && !lastFilter.field) {
            //do not send filter just close the filter window
            applyAdvancedFilter([]);
            onClose();
            setFilterLength(0)
            dispatch({type: ACTIONS.UPDATE_INIT_DATA, payload: {currentFilter, currentFilterFront}})
        }

        //commented, filter have recursive structure, and need to check every record for filter values
        else if (!lastFilter.field && !lastFilter.or && !lastFilter.and) {
            //remove last filter because its empty
            currentFilter.splice(currentFilter.length - 1, 1);
            currentFilterFront.splice(currentFilterFront.length - 1, 1);
            dispatch({type: ACTIONS.UPDATE_CURRENT_FILTER, payload: {currentFilter, currentFilterFront}});
            dispatch({action: ACTIONS.SET_ERRORS, payload: {errors}});
            dispatch({type: ACTIONS.UPDATE_INIT_DATA, payload: {currentFilter, currentFilterFront}})
            //and send request
            onClose();
            //...request
            applyAdvancedFilter(currentFilter);
            setFilterLength(1)
        } else {
            //all is good...send request for filtered data
            setFilterLength(1);
            applyAdvancedFilter(currentFilter)
            dispatch({type: ACTIONS.UPDATE_INIT_DATA, payload: {currentFilter, currentFilterFront}})
            onClose();
            //...request


        }
    };

    function onClosePopover() {
        onClose();
        dispatch({type: ACTIONS.RESTORE_TO_INIT})
    }

    return (
        <SelectionCriteriaContext.Provider value={{
            currentFilterFront: state.currentFilterFront,
            listName: listName,
            type: properties.type,
            filterFields: state.filterFields,
            operands: state.operands,
            actions: {
                onChangeField,
                onChangeOperand,
                onChangeFilterValue,
                onChangeFilterValueExternal,
                onChangeFilterValueRange,
                onCreateFilter,
                onDeleteFilter,
                onDeleteAllFilters,
                apply,
                onChangeType,
            },
            onClose,
            disabled,
            dispatch,
            currentFilter: state.currentFilter,
            hideValueTypeSelection: properties.hideValueTypeSelection
        }}>
            {isPopover ? (
                <Popover anchorEl={anchorEl}
                         PaperProps={{
                             style: {
                                 marginTop: 10,
                                 padding: 15,
                                 border: state.errors ? '1px solid red' : "none",
                             }
                         }}
                         open={Boolean(anchorEl)}
                         onClose={onClosePopover}
                         anchorOrigin={{
                             vertical: 'bottom',
                             horizontal: 'center',
                         }}
                         transformOrigin={{
                             vertical: 'top',
                             horizontal: 'right',
                         }}
                >
                    <div style={{display: 'flex', justifyContent: 'space-between', marginBottom: 10}}>
                        <Typography>
                            Filters
                        </Typography>
                        <IconButton size={'small'} onClick={onClosePopover}>
                            <Close/>
                        </IconButton>
                    </div>
                    <Divider/>
                    {/*<Options/>*/}
                    <SelectionCriteriaDev
                        withoutGroups={withoutGroups}
                    />
                    <PopoverActions cancel={onClosePopover} apply={apply}/>
                    {state.errors && <Errors errors={state.errors}/>}
                </Popover>
            ) : (
                <div style={{
                    display: Boolean(anchorEl) ? 'flex' : 'none',
                    flexDirection: 'column',
                    position: 'relative',
                    border: state.errors ? '1px solid red' : "none",
                    //margin: '10px auto',
                    padding: 5,
                    shadowColor: listStyles.shadowColor,
                    boxShadow: isCustomBoxShadow ? `${listStyles.boxShadow} ${listStyles.shadowColor}` : defaultShadow,
                    ...styles
                }}>
                    <SelectionCriteriaDev
                        withoutGroups={withoutGroups}
                        setValue={setValue} //as component
                        componentPath={properties.path}
                    />
                    {(properties.showApplyButton || !asComponent) && <PopoverActions
                        cancel={history.goBack}
                        apply={apply}
                        applyButtonLabel={properties.applyButtonLabel}
                    />}
                    {state.errors && <Errors errors={state.errors}/>}
                </div>
            )}

        </SelectionCriteriaContext.Provider>
    )
};

SelectionCriteria.propTypes = {
    onClose: PropTypes.func.isRequired,
    anchorEl: PropTypes.any,
    isPopover: PropTypes.bool,
    setFilterLength: PropTypes.func, //should return filter length setFilterLength(length)
    columns: PropTypes.array,
    filterFields: PropTypes.array,
    advancedFilter: PropTypes.array,
    listName: PropTypes.string,
    applyAdvancedFilter: PropTypes.func,
    asComponent: PropTypes.bool, //flag is render by default components
    disabled: PropTypes.bool, //flag from screenDesigner
    withoutGroups: PropTypes.bool,

    setValue: PropTypes.func, //set field values as component
    component: PropTypes.shape({
        properties: PropTypes.shape({
            listId: PropTypes.string,
            path: PropTypes.string,
            allColumns: PropTypes.bool,
            connector: PropTypes.object,
            type: PropTypes.oneOf(['system', 'app'])
        })
    }), //props from component
    screenName: PropTypes.string
};
SelectionCriteria.defaultProps = {
    anchorEl: {},
    setFilterLength: () => {
    },
    onClose: () => {
    },
    listStyles: {},
    history: {},
    advancedFilter: [],
    component: {},
    withoutGroups: true
};

export default JsonScreenHoc(ListHoc(SelectionCriteria));
